import { CheckIcon } from "lucide-react";
import { memo, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import styles from "./GlobalTooltip.module.scss";
import { globalTooltipState } from "../utils";

// Tooltip component that renders into a portal
/**
 * @deprecated - This component is unnecessarily complex and could cause issues
 */
const GlobalTooltip = memo(() => {
  const [, forceUpdate] = useState({});
  const portalRoot = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Create portal container if it doesn't exist
    if (!document.getElementById("tooltip-portal")) {
      const div = document.createElement("div");
      div.id = "tooltip-portal";
      document.body.appendChild(div);
      portalRoot.current = div;
    } else {
      portalRoot.current = document.getElementById(
        "tooltip-portal",
      ) as HTMLDivElement;
    }

    // Set the callback for updating this component
    let frameId: number | null = null;

    const throttledUpdate = () => {
      if (frameId !== null) return; // already scheduled
      frameId = requestAnimationFrame(() => {
        forceUpdate({});
        frameId = null;
      });
    };

    globalTooltipState.tooltipUpdateCallback = throttledUpdate;

    return () => {
      // Clean up
      globalTooltipState.tooltipUpdateCallback = null;
      if (portalRoot.current && portalRoot.current.parentNode) {
        portalRoot.current.parentNode.removeChild(portalRoot.current);
      }
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);

  if (!portalRoot.current || !globalTooltipState.visible) return null;

  const tooltipContent = (
    <div
      style={{
        position: "absolute",
        top: globalTooltipState.position.top,
        left: globalTooltipState.position.left,
      }}
      className={styles.tooltipContainer}
    >
      {globalTooltipState.text}
      {globalTooltipState.text === "Copied" && (
        <CheckIcon className="ml-1 h-4 w-4" />
      )}
    </div>
  );

  return ReactDOM.createPortal(tooltipContent, portalRoot.current);
});

export default GlobalTooltip;
